import React, { useState, useEffect } from 'react';
import '../styles/pages/FlexPortfolio.css';

const FlexPortfolio = ({ 
  activeSection: propActiveSection = 1, 
  portfolioData = [],
  title = "",
  subtitle = ""
}) => {
  const [activeSection, setActiveSection] = useState(propActiveSection);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setActiveSection(propActiveSection);
  }, [propActiveSection]);

  const handleTabChange = (id) => {
    setIsLoading(true);
    setActiveSection(id);
    // Simulate loading for smooth transition
    setTimeout(() => setIsLoading(false), 300);
  };

  // Use the provided portfolio data directly
  const services = portfolioData;

  return (
    <div>
      <section id="portfolio-section" className="portfolio-section-organized">
        <div className="container-organized">
        <div className="portfolio-header">
            <h2>{title}</h2>
            <p className="portfolio-subtitle">{subtitle}</p>
          </div>
          
          <div className="portfolio-tabs-organized">
            {services.map((service) => (
              <button 
                key={service.id} 
                className={`portfolio-tab-organized ${activeSection === service.id ? 'active' : ''}`}
                onClick={() => handleTabChange(service.id)}
              >
                <span className="tab-icon">{service.icon}</span>
                <span className="tab-title">{service.title}</span>
              </button>
            ))}
          </div>
          
          <div className={`portfolio-gallery-organized ${isLoading ? 'loading' : ''}`}>
            {services.find(s => s.id === activeSection)?.gallery.map((image, index) => (
              <div key={index} className="portfolio-item-organized fade-in">
                <img src={image} alt={`${services.find(s => s.id === activeSection)?.title} example ${index + 1}`} />
                <div className="portfolio-overlay">
                  <span className="view-text">View Project</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default FlexPortfolio;
